import { Modal, ModalFuncProps } from 'antd'

type Params = {
  itemName?: string
} & ModalFuncProps

const modalConfirmDelete = (params?: Params) => {
  const { itemName, ...modalFuncProps } = params || {}

  Modal.confirm({
    title: `Xóa ${itemName ? `[${itemName}]` : 'dữ liệu'}`,
    content: 'Dữ liệu sẽ không thể khôi phục sau khi xóa',
    cancelText: 'Quay lại',
    okText: 'Xóa',
    okButtonProps: { danger: true },
    ...modalFuncProps,
  })
}

export default modalConfirmDelete
